
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ICodeAndDescription, ILookupService, LookupCriteria } from "@tylertech/tyler-api-types";

/**
 * AccountOffsetLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class AccountOffsetLookupService {
    constructor(private readonly $apiService: ApiService) { }
    
    Lookup(pCriteria: LookupCriteria): Promise<ICodeAndDescription[]> {
        return this.$apiService.sendAuth("IAccountOffsetLookupService/Lookup", pCriteria);
    }
}
